import { render, staticRenderFns } from "./ProgressBar.global.vue?vue&type=template&id=5491fe3a&scoped=true&lang=pug&"
import script from "./ProgressBar.global.vue?vue&type=script&lang=ts&"
export * from "./ProgressBar.global.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBar.global.vue?vue&type=style&index=0&id=5491fe3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5491fe3a",
  null
  
)

export default component.exports